module.exports = __webpack_public_path__ + "img/vol04_cup02_label04.86e43709.png";